import React from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * Shadcn Input wrapped with an optional left icon + right adornment.
 * forwardRef + {...props} spread pass value/onChange/aria-* straight through
 * to the underlying <input>, so it drops into controlled forms unchanged.
 */
const IconInput = React.forwardRef(
  ({ icon: Icon, rightAdornment, className, ...props }, ref) => (
    <div className="relative">
      {Icon ? (
        <Icon className="pointer-events-none absolute left-3 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-slate-400" />
      ) : null}
      <Input
        ref={ref}
        className={cn(Icon && 'pl-9', rightAdornment && 'pr-10', className)}
        {...props}
      />
      {rightAdornment ? (
        <span className="absolute right-2 top-1/2 z-10 -translate-y-1/2">
          {rightAdornment}
        </span>
      ) : null}
    </div>
  )
);
IconInput.displayName = 'IconInput';

export default IconInput;
